declare type convertFunction = (response: any) => any;
let identity: convertFunction = (data: any) => data;

export function parse<T>(json: any, convert?: (data: any) => T): T {
    convert = convert || identity;

    return convert(json);
}